import React, { useState, useEffect, useRef } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import "../assets/Css/shop.css";
import Slider from "react-slick";
import { shopdetail } from "../Constant/Index";
import { Link } from "react-router-dom";
import {
  seller1,
  seller2,
  seller3,
  seller4,
  review,
  reviewone,
  reviewsecond,
} from "../Constant/Index";

function Shopdetail() {
  // slider
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);

  const sliderSettingsMain = {
    asNavFor: nav2,
    ref: (slider) => (sliderRef1 = slider),
    arrows: false,
    fade: true,
    speed: 500,
  };

  const sliderSettingsThumbs = {
    asNavFor: nav1,
    ref: (slider) => (sliderRef2 = slider),
    slidesToShow: 4,
    swipeToSlide: true,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    centerPadding: "30px",
  };
  // counter
  const [selectedOption, setSelectedOption] = useState("");
  const [quantity, setQuantity] = useState(1);

  const handleSelection = (option) => {
    setSelectedOption(option);
  };

  const handleDecrement = () => {
    setQuantity((prevQuantity) => Math.max(prevQuantity - 1, 1));
  };

  const handleIncrement = () => {
    setQuantity((prevQuantity) => Math.min(prevQuantity + 1, 100));
  };

  const handleChange = (e) => {
    const value = Math.max(1, Math.min(100, Number(e.target.value)));
    setQuantity(value);
  };

  // tab
  const [activeTab, setActiveTab] = useState("pills-home");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  const sellerstuff = [
    {
      img: seller1,
      name: "product name",
      price: "20",
      para: "We believe in natural beauty",
    },
    {
      img: seller2,
      name: "product name",
      price: "20",
      para: "We believe in natural beauty",
    },
    {
      img: seller3,
      name: "product name",
      price: "20",
      para: "We believe in natural beauty",
    },
    {
      img: seller4,
      name: "product name",
      price: "20",
      para: "We believe in natural beauty",
    },
  ];
  const reviews = [
    {
      name: "JOHN DOE",
      rating: 4.5,
      verified: "VERIFIED CLIENT",
      date: "18 04 2024",
      title: "HAPPY WITH THIS PRODUCT",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
      img: review, // Replace with actual image path or URL
      thumbsUp: 10,
      thumbsDown: 10,
    },
    {
      name: "JOHN Samual",
      rating: 4.5,
      verified: "VERIFIED CLIENT",
      date: "18 04 2024",
      title: "HAPPY WITH THIS PRODUCT",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
      img: reviewone, // Replace with actual image path or URL
      thumbsUp: 10,
      thumbsDown: 10,
    },
    {
      name: "JOHN DOE",
      rating: 4.5,
      verified: "VERIFIED CLIENT",
      date: "18 04 2024",
      title: "HAPPY WITH THIS PRODUCT",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
      img: reviewsecond, // Replace with actual image path or URL
      thumbsUp: 10,
      thumbsDown: 10,
    },
    // Add more review objects as needed
  ];
  return (
    <>
      <Header />
      <PageHeader pagename="shop detail" />
      <section className="shopdetail">
        <div className="container">
          <div className="row pb-5 border-bottom">
            <div className="col-lg-6">
              <div className="slider-container">
                <div className="row">
                  <div className="col-lg-2">
                    <Slider
                      {...sliderSettingsThumbs}
                      className="slider-wrapper1"
                    >
                      {[...Array(6)].map((_, index) => (
                        <div className="img-slider" key={index}>
                          <figure>
                            <img
                              src={shopdetail}
                              className="img-fluid"
                              alt=""
                            />
                          </figure>
                        </div>
                      ))}
                    </Slider>
                  </div>
                  <div className="col-lg-10">
                    <Slider {...sliderSettingsMain} className="slider-wrapper">
                      {[...Array(6)].map((_, index) => (
                        <div className="img-wrap-slider" key={index}>
                          <figure>
                            <img
                              src={shopdetail}
                              className="img-fluid"
                              alt=""
                            />
                          </figure>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="slider-heading product-contant">
                <span className="primary-color">Bath Salts</span>
                <h2 className="primary-color">Magnesium Bath Salt Flakes</h2>
              </div>
              <div className="in-stock-rating d-flex align-items-center gap">
                <span className="instock-wrapper">In Stock 05</span>
                <div className="star-rating">
                  <h6 className="m-0">
                    4.5
                    <span>
                      <i
                        className="fa fa-star primary-color"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </h6>
                </div>
                <h5 className="review mb-0">22 Reviews</h5>
              </div>
              <p className="extra-color-6 mt-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </p>
              <span className="product-head-span">Product Variation</span>
              <div className="select-radio">
                <div
                  className={`select-rate ${
                    selectedOption === "single" ? "selected" : ""
                  }`}
                  onClick={() => handleSelection("single")}
                >
                  <input
                    type="radio"
                    name="rate"
                    value="single"
                    checked={selectedOption === "single"}
                    onChange={() => handleSelection("single")}
                    hidden
                  />
                  <h6>Select From Single</h6>
                  <h3>$50.00</h3>
                </div>
                <div
                  className={`select-rate ${
                    selectedOption === "box" ? "selected" : ""
                  }`}
                  onClick={() => handleSelection("box")}
                >
                  <input
                    type="radio"
                    name="rate"
                    value="box"
                    checked={selectedOption === "box"}
                    onChange={() => handleSelection("box")}
                    hidden
                  />
                  <h6>Box Of 3</h6>
                  <h3>$100.00</h3>
                </div>
              </div>
              <span className="product-head-span">Select Quantity</span>
              <div className="d-flex align-items-center gap-3 mt-2">
                <div className="quantity-selector">
                  <button onClick={handleDecrement} disabled={quantity <= 1}>
                    <i className="fas fa-minus"></i>
                  </button>
                  <input
                    type="number"
                    value={quantity}
                    onChange={handleChange}
                    min={1}
                    max={100}
                  />
                  <button onClick={handleIncrement} disabled={quantity >= 100}>
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
                <h4 className="quantity-rate-wrapper">$45.00</h4>
              </div>
              <div className="d-flex align-items-center gap-3 mt-3">
                <Link
                  className="btn-all-wrapper ml-0 bg-transparent dark-color1 my-btn-border border"
                  to="/cart"
                >
                  Add To Cart
                </Link>
                <Link
                  className="btn-all-wrapper ml-3 bg-transparent my-btn-border dark-color1 border"
                  to="/wishlist"
                >
                  Add To Wishlist
                </Link>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-lg-12">
              <ul
                className="nav nav-pills d-flex  mb-3"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item margin-wrapper" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "pills-home" ? "active" : ""
                    }`}
                    id="pills-home-tab"
                    onClick={() => handleTabClick("pills-home")}
                  >
                    Product Description
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "pills-profile" ? "active" : ""
                    }`}
                    id="pills-profile-tab"
                    onClick={() => handleTabClick("pills-profile")}
                  >
                    Reviews
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className={`tab-pane fade ${
                    activeTab === "pills-home" ? "show active" : ""
                  }`}
                  id="pills-home"
                >
                  <div class="slider-heading-tab ">
                    <h2 class="primary-color">Magnesium Bath Salt Flakes</h2>
                    <p class="extra-color-6 ">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidatat non proident, sunt in culpa qui
                      officia deserunt mollit anim id est laborum.Lorem ipsum
                      dolor sit amet, consectetur adipiscing elit, sed do
                      eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidatat non proident, sunt in culpa qui
                      officia deserunt mollit anim id est laborum.
                    </p>
                  </div>
                  <div class="slider-heading-tab ">
                    <h2 class="primary-color">Addtional Info</h2>
                    <p class="extra-color-6 ">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderi
                      <br />
                      <br />
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                      <br />
                      <br />
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do
                    </p>
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${
                    activeTab === "pills-profile" ? "show active" : ""
                  }`}
                  id="pills-profile"
                >
                  <div class="slider-heading-tab d-flex align-items-center justify-content-between">
                    <h2 class="primary-color">Reviews</h2>
                    <h6>03</h6>
                  </div>
                  <div className="row border-hide-wrapper">
                    {reviews.map((review, index) => (
                      <div
                        className="col-lg-12 border-bottom pb-2 mt-4"
                        key={index}
                      >
                        <div className="review-details-content-img-wrapper">
                          <div className="position-relative">
                            <img
                              src={review.img}
                              className="img-fluid"
                              alt=""
                            />
                            <div className="check-wrapper">
                              <i className="fa-solid fa-check"></i>
                            </div>
                          </div>
                          <div className="start-content-div">
                            <div>
                              <div className="name-star">
                                <h4>{review.name}</h4>
                                <div className="star-rating">
                                  <h6>
                                    <span>
                                      {[
                                        ...Array(Math.floor(review.rating)),
                                      ].map((_, i) => (
                                        <i
                                          className="fa fa-star primary-color"
                                          aria-hidden="true"
                                          key={i}
                                        ></i>
                                      ))}
                                      {review.rating % 1 !== 0 && (
                                        <i
                                          className="fa fa-star primary-color"
                                          aria-hidden="true"
                                        ></i>
                                      )}
                                    </span>
                                    {review.rating}
                                  </h6>
                                </div>
                              </div>
                              <h5>{review.verified}</h5>
                            </div>
                            <h6>{review.date}</h6>
                          </div>
                        </div>
                        <div className="slider-heading-tab mt-3">
                          <h2 className="primary-color">{review.title}</h2>
                          <p className="primary-color">{review.content}</p>
                        </div>
                        <div className="row ">
                          <div className="col-lg-12">
                            {/* <div className="rating-thumb">
                              <h4>WAS THIS REVIEW HELPFUL?</h4>
                              <div className="thumb-icon">
                                <h6>
                                  <i className="fa-solid fa-thumbs-up"></i>
                                  {review.thumbsUp}
                                </h6>
                              </div>
                              <div className="thumb-icon thumb-down">
                                <h6>
                                  <i className="fa-solid fa-thumbs-down"></i>
                                  {review.thumbsDown}
                                </h6>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Product Section  */}
      <section className="Related-Prdocuts-sec">
        <div className="container">
          <div className="best-seller-heading mt-4">
            <h2 className="primary-color">Related Products</h2>
          </div>
          <div className="row">
            {sellerstuff?.map((data, sellerindex) => {
              return (
                <>
                  <div className="col-md-3" key={sellerindex}>
                    <div className="seller-all">
                      <div className="seller-img">
                        <img src={data?.img} className="img-fluid" />
                        <div className="add-to-cart">
                          <span className="primary-color">
                            {" "}
                            <i
                              class="fa fa-shopping-basket"
                              aria-hidden="true"
                            ></i>
                            <button className="priamry-color">
                              add to cart
                            </button>
                          </span>
                          <span className="primary-color primary-heart">
                            <i class="fa fa-heart" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                      <div className="seller-head-para">
                        <h3 className="primary-color">
                          {data?.name} <span> | {data?.price}</span>
                        </h3>
                        <p>{data?.para}</p>
                      </div>
                      <div className="seller-stars">
                        <ul>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star extra-color-6"
                              aria-hidden="true"
                            ></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </section>
      {/* =========================== */}
      <Footer />
    </>
  );
}

export default Shopdetail;
